import { Switch as SwitchPrimitive, type SwitchRootProps } from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

interface SwitchProps extends SwitchRootProps {
  thumbClassName?: string;
  labelWrapperClassName?: string;
  label?: string;
  withIndicators?: "word" | "icon";
  classNames?: {
    root?: string;
    control?: string;
    thumb?: string;
    label?: string;
  };
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.HiddenInput>,
  SwitchProps
>((props, ref) => {
  const { className, classNames, label, withIndicators, ...rest } = props;

  return (
    <SwitchPrimitive.Root
      className={clsx("ox-reset ox-SwitchRoot", classNames?.root)}
      {...rest}
    >
      <SwitchPrimitive.Control
        className={clsx(
          "ox-reset",
          "ox-ui-Switch",
          className,
          classNames?.control,
        )}
      >
        <SwitchPrimitive.Thumb
          className={clsx("ox-ui-SwitchThumb", classNames?.thumb)}
        />

        {withIndicators ? (
          <span aria-hidden className="ox-reset ox-SwitchInnerUnchecked">
            {withIndicators === "word" ? (
              "No"
            ) : withIndicators === "icon" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="#000000"
                viewBox="0 0 256 256"
              >
                <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
              </svg>
            ) : null}
          </span>
        ) : null}

        {withIndicators ? (
          <span aria-hidden className="ox-reset ox-SwitchInnerChecked">
            {withIndicators === "word" ? (
              "Yes"
            ) : withIndicators === "icon" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="#ffffff"
                viewBox="0 0 256 256"
              >
                <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"></path>
              </svg>
            ) : null}
          </span>
        ) : null}
      </SwitchPrimitive.Control>

      {label ? (
        <SwitchPrimitive.Label
          className={clsx("ox-reset ox-FormLabel", classNames?.label)}
        >
          {label}
        </SwitchPrimitive.Label>
      ) : null}
      <SwitchPrimitive.HiddenInput ref={ref} />
    </SwitchPrimitive.Root>
  );
});

Switch.displayName = "Switch";
export { Switch };
export type { SwitchProps };
